import React from 'react';

const PageLayout = ({ title, children }) => (
  <div style={{ minHeight: '70vh', padding: '60px 0' }}>
    <div className="container">
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8, color: '#2D1A00' }}>{title}</h1>
      <div style={{ width: 60, height: 3, background: '#D4A843', borderRadius: 2, marginBottom: 30 }}></div>
      <div style={{ background: '#fff', borderRadius: 16, padding: '32px', border: '1px solid #E0D0B8', lineHeight: 1.8, fontSize: 14, color: '#4A4A4A' }}>
        {children}
      </div>
    </div>
  </div>
);

export default PageLayout;
